import React from 'react';
import Highcharts from 'highcharts/highcharts';
import HighchartsReact from 'highcharts-react-official';

import { InlineMath, BlockMath } from 'react-katex';
import 'katex/dist/katex.min.css';

import data from './data';
import pred from './pred';

const options = {
  credits: {
    enabled: false
  },
  plotOptions: {
    series: {
      enableMouseTracking: false,
      lineWidth: 1,
    },
  },
  yAxis: {
    title: { enabled: false },
    min: -0.6,
    max: 0.4,
    tickInterval: 0.1
  },
  title: {
    text: 'Mackey-Glass Prediction',
    margin: 1,
    style: { fontSize: '12px' },
  },
  series: [
    {
      data: data.slice(1800, 2701),
      name: 'Training Data'
    },
    {
      data: pred.slice(0, 700),
      name: 'Reservoir Prediction'
    }
  ]
};

const opts = { style: { height: '200px', width:'100%' }};

function MackeyGlass() {
  return (
    <div>
      <h5 className="text-uppercase">Basic Case</h5>
      <p>
        We start by using the Mackey-Glass<sup>[<a href="http://www.scholarpedia.org/article/Mackey-Glass_equation" target="_blank" rel="noopener noreferrer" style={{ color: '#000' }}>4</a>]</sup> nonlinear time delay differential equation
      </p>
      <BlockMath>{` \\frac{dx}{dt} = \\beta \\frac{x_{\\tau}}{1+x^{n}_{\\tau}} - \\gamma x, \\; \\; \\gamma,\\beta,n > 0`}</BlockMath>
      <div className="d-flex flex-wrap w-100">
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          containerProps={opts}
        />
      </div>
      <p>
        Using <InlineMath>500</InlineMath> training data points, <InlineMath>1024</InlineMath> reservoir units and a spectral radius of <InlineMath>1.5</InlineMath>, we establish a basis for predicting an oscillating series.
      </p>
    </div>
  );
}

export default MackeyGlass;
